$('.newaddtocart').click(function (e) {
    e.preventDefault()
    e.stopPropagation()
    let data = [];
    let var_id = $('.product-form__input--pill input[type=radio]:checked').attr('var-id')
    let title = $('.product-form__input--pill input[type=radio]:checked').val()
    let variant_title = parseInt(title.split( )[0])
    let qty = parseInt($('.quantity__input').val()) || 1;
    let isSubscription = $('.pvo-input-container.active');
    let selling_id = $('.product-form__input--pill input[type="radio"]:checked + label')
    const bundleId = Math.floor(1000 + Math.random() * 9000);
    const product = (isSubscription.length == 0 ? withOut_subs : with_subs).find(item => item.variant_id == parseInt(var_id));
    product.free_variant_ids.forEach(id => {
        data.push({
            id: id.toString(),
            quantity: 1,
            properties: {
            _bundle_id: bundleId,
            __smart_discount_flow_properties: '__free'
            }
        });
    });
    data.push({
        id: var_id,
        quantity: qty,
        properties: {_bundle_id: bundleId},
        ...(isSubscription.length > 0
        ? { selling_plan: (selling_id?.attr('data-selling')?.toString()) }
        : {})
    });
    console.log(data, 'final items');
    //return
    $.ajax({
    method: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: { items: data },
    success: function (cart) {
        fetch(`${routes.cart_url}?sections=cart-drawer`)
            .then((response) => response.json())
            .then((sections) => {
            const sectionIds = ['cart-drawer'];
            for (const sectionId of sectionIds) {
                const htmlString = sections[sectionId];
                const html = new DOMParser().parseFromString(htmlString, 'text/html');
                const sourceElement = html.querySelector(`${sectionId}`);
                const targetElement = document.querySelector(`${sectionId}`);
                if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
                }
            }
            document.body.classList.add('overflow-hidden');
            const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
            theme_cart.classList.add('active');
            })
            .catch((e) => {
            console.error('Error updating cart sections:', e);
        });
    },
    error: function (response) {
        console.log(response.responseJSON.description);
    }
    });
})

document.addEventListener("click",function (e) {
          const btn = e.target.closest("button.unicorn_button.items_remove__qS11A.unicorn_cart_cell_remove");
          if (!btn) return;
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          console.log("Custom remove logic");
          const rowIndex = btn.closest('tr').rowIndex;
          const tit = parseInt( btn.closest('.unicorn_cart_item') .querySelector('a') .getAttribute('href') .split('variant=') .pop(), 10 );
 
            let get_key;
            const currentItem =
            unicornCartData.items.length === 1
                ? unicornCartData.items[0]
                : unicornCartData.items[rowIndex];

            get_key = currentItem?.properties?.find((p) => p[0] === "_bundle_id")?.[1];
            const updates = {};
            if (get_key) {
            unicornCartData.items.forEach((item) => {
                const id = item?.properties?.find((p) => p[0] === "_bundle_id")?.[1];
                if (id === get_key && item.key) {
                updates[item.key] = 0;
                }
            });
            console.log(get_key, 'get_key','else');
            }else {            
            const item = unicornCartData.items[rowIndex-1];
            console.log(item, 'item','ifff');        
            if (item?.key) {
                updates[item.key] = 0;
            }
            }
            
           

            $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: {
                    updates: updates
                },
                dataType: 'json',
                success: function(res) {
                    console.log('Removed from cart', res);
                    unicornRefreshCart()
                },
                error: function(err) {
                    console.error('Error removing items:', err);
                }
            });
            return false;
        },
        true
      );


window.openCartDrawerss = function (id) {
    let isSubscription = $('.pvo-input-container.active');
    const product = (isSubscription.length == 0 ? withOut_subs : with_subs).find(item => item.variant_id == id);
    if (!product || !Array.isArray(product.image)) {
        console.log('Image array not found');
        return;
    }
    const image =  !(product.variant_title === '1 Dose' && product.has_selling_plan?.length === 0) ? [
        product.Gift_image,
        ...product.image
      ] : product.image;
    $('.Gift_container .__gift').removeClass('active');
    $('.Gift_container .__gift').each(function(index, element) {
        if (image[index]) {
            $(this).find('.gifts__gift__image').attr('src', image[index]);
            $(this).addClass('active');
        }
        $(this).find('.gift__title').text(product.free_variant_title[index])
        $(this).find('.__gift__label__text').text(product.free_variant_price[index])
    });
    const $labels = $('fieldset.js.product-form__input.product-form__input--pill label');
    if (isSubscription.length > 0) {
        $('.Price_withOut_sellingPlan,.discount_variant_image').hide();
        $('.Price_with_sellingPlan,.option-title-rabatt').show();
    } else {
        $('.Price_with_sellingPlan,.option-title-rabatt').hide();
        $('.Price_withOut_sellingPlan,.discount_variant_image').show();
    }
    
    if(product.price===product.compare_at_price){
        $('button.newaddtocart .Compare__Priceee').hide()
    }else{
        $('button.newaddtocart .Compare__Priceee').show()
    }
    $('button.newaddtocart .Priceee').text(
        product.has_selling_plan.length > 0
            ? product.has_selling_plan
            : product.price
        );
    $('button.newaddtocart .Compare__Priceee').text(product.compare_at_price)

};

$(document).on("click", ".pvo-input-container", function(e) {
    $(this).toggleClass('active');
    let isSubscription = $('.pvo-input-container.active');
    const $labels = $('fieldset.js.product-form__input.product-form__input--pill label');

    if (isSubscription.length > 0) {
        $('.Price_withOut_sellingPlan,.discount_variant_image').hide();
        $('.Price_with_sellingPlan,.option-title-rabatt').show();
        $('.__gift[index="4"] .gift__title_unlocked').text('2+ Dosen')
    } else {
        $('.Price_with_sellingPlan,.option-title-rabatt').hide();
        $('.Price_withOut_sellingPlan,.discount_variant_image').show();
        $('.__gift[index="4"] .gift__title_unlocked').text('Abonnieren oder 3+ Packungen')
    }
    let id = parseInt($('.product-form__input--pill input[type=radio]:checked').attr('var-id'))
    const product = (isSubscription.length == 0 ? withOut_subs : with_subs)
        .find(item => item.variant_id == id);
    if (!product || !Array.isArray(product.image)) {
        console.log('Image array not found');
        return;
    }
    const image =  !(product.variant_title === '1 Dose' && product.has_selling_plan?.length === 0) ? [
        product.Gift_image,
        ...product.image
      ] : product.image;
    
    
console.log(image,product)
    $('.Gift_container .__gift').removeClass('active'); 
    $('.Gift_container .__gift').each(function(index, element) {
        if (image[index]) {
            $(this).find('.gifts__gift__image').attr('src', image[index]);
            $(this).addClass('active');
        }
        $(this).find('.gift__title').text(product.free_variant_title[index])
        $(this).find('.__gift__label__text').text(product.free_variant_price[index])
    });

    if(product.price===product.compare_at_price){
        $('button.newaddtocart .Compare__Priceee').hide()
    }else{
        $('button.newaddtocart .Compare__Priceee').show()
    }
    $('button.newaddtocart .Priceee').text(
        product.has_selling_plan.length > 0
            ? product.has_selling_plan
            : product.price
        );
    $('button.newaddtocart .Compare__Priceee').text(product.compare_at_price)
});



$(document).ready(function() {
    let isSubscription = $('.pvo-input-container.active');
    let id = parseInt(window.location.href.split('?variant=').pop())
    if(id){   
        const product = (isSubscription.length == 0 ? withOut_subs : with_subs).find(item => item.variant_id == id);
        if (!product || !Array.isArray(product.image)) {
            console.log('Image array not found');
            return;
        }
        const image =  !(product.variant_title === '1 Dose' && product.has_selling_plan?.length === 0) ? [
        product.Gift_image,
        ...product.image
        ] : product.image;
        $('.Gift_container .__gift').removeClass('active');
        $('.Gift_container .__gift').each(function(index, element) {
            if (image[index]) {
                $(this).find('.gifts__gift__image').attr('src', image[index]);
                $(this).addClass('active');
            }
            $(this).find('.gift__title').text(product.free_variant_title[index])
            $(this).find('.__gift__label__text').text(product.free_variant_price[index])
        });
        
    }
   $('.pvo-input-container').click()
   $('fieldset.js.product-form__input.product-form__input--pill label').eq(0).trigger('click');
   if(document.querySelector('.product-form__input input[type="radio"]')){
    document.querySelector('.product-form__input input[type="radio"]').click()
   }
   
   $('fieldset.js.product-form__input.product-form__input--pill label:last-child').click();
});